import { render, staticRenderFns } from "./StringFormatter.Replace.vue?vue&type=template&id=2834ab39&scoped=true"
import script from "./StringFormatter.Replace.vue?vue&type=script&lang=js"
export * from "./StringFormatter.Replace.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.Replace.vue?vue&type=style&index=0&id=2834ab39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834ab39",
  null
  
)

export default component.exports